// extracted by mini-css-extract-plugin
export var addButton = "_d1-0";
export var border = "_d1-8";
export var check = "_d1-h";
export var danger = "_d1-6";
export var dropdownContainer = "_d1-1";
export var editModalBody = "_d1-j";
export var footerContainer = "_d1-i";
export var fullWidth = "_d1-a";
export var hide = "_d1-9";
export var icon = "_d1-3";
export var input = "_d1-7";
export var inputFlex = "_d1-b";
export var inputWrapper = "_d1-c";
export var manualFocus = "_d1-5";
export var optionButton = "_d1-4";
export var pillWrapper = "_d1-e";
export var pointer = "_d1-2";
export var showOverflow = "_d1-f";
export var tagsFlex = "_d1-d";
export var xButton = "_d1-g";